import React from "react";
import { Route, Redirect } from "react-router-dom";


const isUserAuthenticated = () => {
  return localStorage.getItem("token") !== null;
};

const PrivateRoute = ({ component: Component, ...props }) => {
  return (
    <Route
      {...props}
      render={() => {
        
        if (isUserAuthenticated()) {
          return <Component />;
        }
        return <Redirect to="/Login" />;
      }}
    />
  );
};

export default PrivateRoute;